// src/api/footerService.ts
import api from './config';

export interface FooterItem {
  id?: number;
  section: string;       // 'skills' | 'social' | 'links'
  category: string;      // column heading
  label: string;         // display text
  url?: string | null;   // href for social/links items
  display_order: number;
}

export const getFooterItems = async (): Promise<FooterItem[]> => {
  const response = await api.get('/api/footer');
  return response.data.data;
};

export const getFooterItemById = async (id: number): Promise<FooterItem> => {
  const response = await api.get(`/api/footer/${id}`);
  return response.data.data;
};

export const createFooterItem = async (
  item: Omit<FooterItem, 'id'>
): Promise<FooterItem> => {
  const response = await api.post('/api/footer', item);
  return response.data.data;
};

export const updateFooterItem = async (
  id: number,
  item: Partial<FooterItem>
): Promise<FooterItem> => {
  const response = await api.put(`/api/footer/${id}`, item);
  return response.data.data;
};

export const deleteFooterItem = async (id: number): Promise<void> => {
  await api.delete(`/api/footer/${id}`);
};
